import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import WideContainer, { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

export const Wrap = styled.div`    
    flex-direction: row-reverse;
    flex-wrap: nowrap;
    width: inherit;
    word-break: break-word;
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-wrap: wrap-reverse;
    }
`;
export const Container = styled(WideContainer)`
    padding-top: 18px;
    padding-bottom: 18px;
    position: relative;
`;

export const ButtonBack = styled(Button)`
    margin-bottom: 52px;
    
    @media (max-width: ${wideBreakpoints.mobile}){
        display: none;
    }
`;
